/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MeetingStrategy } from './MeetingStrategy';
import {
    MeetingStrategyFromJSON,
    MeetingStrategyFromJSONTyped,
    MeetingStrategyToJSON,
    MeetingStrategyToJSONTyped,
} from './MeetingStrategy';
import type { Field } from './Field';
import {
    FieldFromJSON,
    FieldFromJSONTyped,
    FieldToJSON,
    FieldToJSONTyped,
} from './Field';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';
import type { GoogleCalendar } from './GoogleCalendar';
import {
    GoogleCalendarFromJSON,
    GoogleCalendarFromJSONTyped,
    GoogleCalendarToJSON,
    GoogleCalendarToJSONTyped,
} from './GoogleCalendar';
import type { Domain } from './Domain';
import {
    DomainFromJSON,
    DomainFromJSONTyped,
    DomainToJSON,
    DomainToJSONTyped,
} from './Domain';
import type { Workspace } from './Workspace';
import {
    WorkspaceFromJSON,
    WorkspaceFromJSONTyped,
    WorkspaceToJSON,
    WorkspaceToJSONTyped,
} from './Workspace';

/**
 * 
 * @export
 * @interface Meeting
 */
export interface Meeting {
    /**
     * The unique identifier for this meeting
     * @type {string}
     * @memberof Meeting
     */
    id: string;
    /**
     * Whether this meeting is currently active and accepting bookings
     * @type {boolean}
     * @memberof Meeting
     */
    enabled: boolean;
    /**
     * The domain that this meeting belongs to
     * @type {Domain}
     * @memberof Meeting
     */
    domain: Domain;
    /**
     * URL-safe name for the meeting
     * @type {string}
     * @memberof Meeting
     */
    niceName: string;
    /**
     * The user that created this meeting
     * @type {User}
     * @memberof Meeting
     */
    user: User;
    /**
     * The Google calendar associated with this meeting
     * @type {GoogleCalendar}
     * @memberof Meeting
     */
    calendar: GoogleCalendar;
    /**
     * The Workspace associated with this meeting
     * @type {Workspace}
     * @memberof Meeting
     */
    workspace: Workspace;
    /**
     * 
     * @type {MeetingStrategy}
     * @memberof Meeting
     */
    strategy: MeetingStrategy;
    /**
     * All custom fields
     * @type {Array<Field>}
     * @memberof Meeting
     */
    fields: Array<Field>;
}

/**
 * Check if a given object implements the Meeting interface.
 */
export function instanceOfMeeting(value: object): value is Meeting {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('domain' in value) || value['domain'] === undefined) return false;
    if (!('niceName' in value) || value['niceName'] === undefined) return false;
    if (!('user' in value) || value['user'] === undefined) return false;
    if (!('calendar' in value) || value['calendar'] === undefined) return false;
    if (!('workspace' in value) || value['workspace'] === undefined) return false;
    if (!('strategy' in value) || value['strategy'] === undefined) return false;
    if (!('fields' in value) || value['fields'] === undefined) return false;
    return true;
}

export function MeetingFromJSON(json: any): Meeting {
    return MeetingFromJSONTyped(json, false);
}

export function MeetingFromJSONTyped(json: any, ignoreDiscriminator: boolean): Meeting {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'enabled': json['enabled'],
        'domain': DomainFromJSON(json['domain']),
        'niceName': json['niceName'],
        'user': UserFromJSON(json['user']),
        'calendar': GoogleCalendarFromJSON(json['calendar']),
        'workspace': WorkspaceFromJSON(json['workspace']),
        'strategy': MeetingStrategyFromJSON(json['strategy']),
        'fields': ((json['fields'] as Array<any>).map(FieldFromJSON)),
    };
}

export function MeetingToJSON(json: any): Meeting {
    return MeetingToJSONTyped(json, false);
}

export function MeetingToJSONTyped(value?: Meeting | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'enabled': value['enabled'],
        'domain': DomainToJSON(value['domain']),
        'niceName': value['niceName'],
        'user': UserToJSON(value['user']),
        'calendar': GoogleCalendarToJSON(value['calendar']),
        'workspace': WorkspaceToJSON(value['workspace']),
        'strategy': MeetingStrategyToJSON(value['strategy']),
        'fields': ((value['fields'] as Array<any>).map(FieldToJSON)),
    };
}

